module.exports = __webpack_public_path__ + "assets/img/Eimele-1-Landing-Page-w540.6b02d3bf.webp";